import { Component, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UpgradePromptData, UpgradePromptService } from './upgrade-prompt.service';

@Component({
  selector: 'app-upgrade-prompt',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="pro-feature-modal-overlay" *ngIf="prompt" (click)="close()">
      <div class="pro-feature-modal" (click)="$event.stopPropagation()">
        <button type="button" class="pro-feature-modal-close" (click)="close()" aria-label="Close">
          <i class="fas fa-times"></i>
        </button>
        <div class="pro-feature-modal-coin">
          <i class="fas fa-crown"></i>
        </div>
        <span class="pro-badge">PRO</span>
        <h3 class="pro-feature-modal-title">{{ prompt.title }}</h3>
        <p class="pro-feature-modal-text">{{ prompt.message }}</p>
        <p class="pro-feature-modal-subtext">Upgrade to Pro to unlock:</p>
        <ul class="upgrade-prompt-features">
          <li *ngFor="let feature of upgradePrompt.features">{{ feature }}</li>
        </ul>
        <div class="upgrade-prompt-actions">
          <button type="button" class="btn btn-primary" (click)="upgrade()">Upgrade to Pro</button>
          <button type="button" class="btn btn-outline-light" (click)="close()">Not now</button>
        </div>
      </div>
    </div>
  `,
})
export class UpgradePromptComponent implements OnDestroy {
  prompt: UpgradePromptData | null = null;
  private destroy$ = new Subject<void>();

  constructor(readonly upgradePrompt: UpgradePromptService) {
    this.upgradePrompt.prompt$.pipe(takeUntil(this.destroy$)).subscribe((prompt) => {
      this.prompt = prompt;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  close(): void {
    this.upgradePrompt.hide();
  }

  upgrade(): void {
    this.upgradePrompt.goToBilling();
  }
}
